import { Component, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { CommandController } from '../../../core/component/base/command-controller.base';
import { ColumnDefinition } from '../../../core/model/column-definition';
import { MenuItemDefinition } from '../../../core/model/menu-item-definition';
import { CommandDispatcher } from '../../../core/service/command/command-dispatcher.service';
import { ColumnDefinitionFactory } from '../../../core/service/factory/column-definition-factory.service';
import { FormControlExFactory } from '../../../core/service/factory/form-control-ex-factory.service';
import { DirectDebitCommandHandlerResolver } from '../../service/command/direct-debit-command-handler-resolver.service';
import { CompanyService } from '../../../rent/service/data/company.service';
import { LocalDate } from '../../../core/model/local-date';
import { ObjectManagerComponentBase } from '../../../core/component/object-manager/object-manager.base';
import { MessageService } from '../../../core/service/message.service';
import { NavigationService } from '../../../core/service/navigation.service';
import { B2CSubscriptionService } from '../../service/data/b2c-subscription.service';
import { B2CSubscription } from '../../model/b2c/b2c-subscription';
//import { directDebitCommand } from '../../command/direct-debit'; // <-- TODO: put new command component over here

@Component({
    selector: 'app-b2c-subscriptions',
    templateUrl: './b2c-subscriptions.component.html',
    styleUrls: ['./b2c-subscriptions.component.scss'],
    providers: [DirectDebitCommandHandlerResolver],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class B2CSubscriptionsComponent extends ObjectManagerComponentBase<B2CSubscription> {
  constructor(
    private _dataService: B2CSubscriptionService,
    cdf: ColumnDefinitionFactory,
    dispatcher: CommandDispatcher,
    private _companyService: CompanyService,
    fb: FormBuilder,
    fcf: FormControlExFactory,
    messageService: MessageService,
    navigationService: NavigationService,
    handlerResolver: DirectDebitCommandHandlerResolver // TODO --------------------- Fix new CommandHandlerResolver
  ) {
    super(_dataService, messageService, navigationService, dispatcher, handlerResolver);

    this.from = LocalDate.fromDate(LocalDate.today().addMonths(-1)); // TODO -- what is resonable default?
    this.to = LocalDate.fromDate(LocalDate.today());

    // TODO: filters.... what is needed?
    this.form = fb.group({
      from: fb.group({}),
      to: fb.group({}),
      company: fcf.create('COMPANY.LIST_HEADER', ''),
      payerName: fcf.create('INVOICE.RECIPIENT_NAME', ''),
    });

    this.columnDefinitions = [
      //cdf.create('WIP Id', 'id'), // remove in prod
      cdf.createTranslation('B2C_SUBS.STATE', 'state.translated'),
      cdf.create('B2C_SUBS.COMPANY_NAME', 'company.name'),
      cdf.create('B2C_SUBS.ISSUER', 'identity.issuer'),
      cdf.create('B2C_SUBS.RECIPIENT', 'identity.recipient'),
      //cdf.create('INVOICE.RECIPIENT_NAME', 'debtorName'),
      //cdf.create('DIRECT_DEBIT.PAYMENT_STATUS', 'paymentStatusCodeText'),
      //cdf.create('DIRECT_DEBIT.INVOICE_NUMBER', 'invoiceNumber'),
      //cdf.createDateColumnDefinition('INVOICE.DUE_DATE', 'invoiceDueDate'),
      //cdf.createMoneyColumnDefinition('DIRECT_DEBIT.AMOUNT', 'amount'),
      //cdf.createMoneyColumnDefinition('DIRECT_DEBIT.REMAINING_AMOUNT', 'unPaidAmount')
    ];

    this.addContextMenuItemDefinition('WIP - TODO', 'Todo');
    this.preferencesKey = 'invoice.b2c-subscriptions';
    //this.addContextMenuItemDefinition('COMMON.OPEN_INVOICE', directDebitCommand.openInvoice);
  }

  from: LocalDate;
  to: LocalDate;

  columnDefinitions: ColumnDefinition[];
  dataContext: B2CSubscription[];
  form: FormGroup;
  companies: { name: string; value: string }[];

  ngOnInit() {
    // TODO: call super ???
    this._companyService.getList().subscribe(data => {
      this.companies = [{ name: 'ALL_TEXT', value: '' }];
      data.forEach(item => {
        this.companies.push({ name: item.toString(), value: item.id });
      });
    });

    this._dataService
      .getFilteredList(this.form.value) // TODO refactor?
      .subscribe(items => {
        this.dataContext = items;
      });
  }

  onSubmit() {
    // TODO: call super ???
    if (this.form.invalid) return;

    this._dataService.getFilteredList(this.form.value).subscribe(items => {
      this.dataContext = items;
    });
  }
}
